import { FC, PropsWithChildren } from 'react';
import { CatHeader } from '@blocks-react/components/Header';

export const SubheaderContainer: FC<PropsWithChildren> = ({ children }) => (
  <CatHeader data-testid="subheader-container">{children}</CatHeader>
);
